export default __webpack_public_path__ + "static/media/noise.522bcb83.png";